import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=0ecd5cfa&scoped=true&"
import script from "./SwitchButton.vue?vue&type=script&lang=ts&"
export * from "./SwitchButton.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchButton.vue?vue&type=style&index=0&id=0ecd5cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd5cfa",
  null
  
)

export default component.exports